export const VALIDATION_MESSAGES = {
  REQUIRED: "This field is required",
  INVALID_EMAIL: "Please enter a valid email address",
  MIN_LENGTH: "Minimum length is required",
  NUMBERS_ONLY: "Only numbers are allowed",
};

